import { cn } from '@/lib/utils'

/**
 * Der Rahmen jedes Handy-Screens.
 *
 * Feste Bildschirmhöhe statt Dokumentfluss: die App füllt genau ein
 * Handydisplay, gescrollt wird nur innerhalb der Inhaltsfläche. Die
 * safe-area-Abstände halten Inhalte aus Notch und Home-Indikator heraus.
 */
export function PhoneShell({
    children,
    className,
}: {
    children: React.ReactNode
    className?: string
}) {
    return (
        <div
            className={cn(
                'flex h-dvh w-full flex-col overflow-hidden bg-wb-bg text-wb-text',
                'px-5 pt-[max(1.25rem,env(safe-area-inset-top))]',
                'pb-[max(1.25rem,env(safe-area-inset-bottom))]',
                className,
            )}
        >
            {children}
        </div>
    )
}
